import * as React from "react";
import {useEffect, useState} from "react";
import {getDocumentation} from "./BackendFacade/apiCalls";
import docuStyles from "./Documentation.module.css";
import ReactMarkdown from "react-markdown";
import {GlobalDictionary} from "../../Utils/globalDictionary";
import remarkGfm from "remark-gfm";
import {useMain} from "../../Utils/SessionControls/mainContext";
import {transformOdxLayoutRef} from '../../OdxComponents/odxLayoutRef'
import OdxChip from '../../OdxComponents/NativeOdx/Odx-Chip'
import OdxContentBox from "../../OdxComponents/NativeOdx/Odx-Contentbox";

interface DocumentationProps {
    component: string;
}

const Documentation: React.FC<DocumentationProps> = ({component}) => {
    const [content, setContent] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const {createErrorToast} = useMain();
    const containerRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        transformOdxLayoutRef(containerRef.current);
    }, []);

    useEffect(() => {
        const retrieveDocumentation = async () => {
            if (!component) {
                return;
            }
            const cachedContent = GlobalDictionary.get("Docu" + component);
            if (cachedContent) {
                setContent(cachedContent);
                return;
            }
            setLoading(true);
            try {
                const response = await getDocumentation(component);
                if (response.success) {
                    setContent(response.data.value);
                    if (response.data.value.includes("&")) {
                        const index = response.data.value.indexOf("&");
                    }
                    GlobalDictionary.set("Docu" + component, response.data.value);
                } else {
                    createErrorToast("Error", response.message);
                }
            } catch (error) {

            } finally {
                setLoading(false);
            }
        };

        retrieveDocumentation();
    }, [component]);

    const customLink = (href: string, children: React.ReactNode) => {
        const url = href.replace(/&/g, '&');
        return <a target={"_blank"} rel={"noreferrer"} href={url}>{children}</a>;
    };


    return (
        <>
            <div className={docuStyles.DocuText}>
                {loading ? <p>Loading...</p>
                    :
                    <ReactMarkdown children={content} remarkPlugins={[remarkGfm]} components={{
                        a: props => {
                            return customLink(props.href, props.children);
                        },
                        p: props => {
                            return (
                                <OdxContentBox>
                                    {props.children.toString().includes("{Type}")
                                        ? <OdxChip size={"small"}
                                                   content={props.children.toString().replace("{Type}: ", "")}/>
                                        : <p>{props.children}</p>}
                                </OdxContentBox>
                            );
                        },
                        ul: props => {
                            return <ul className={"list-inside"}>{props.children}</ul>;
                        },
                        h1: props => {
                            return null;
                        },
                    }}/>
                }
            </div>
        </>
    );
};

export default Documentation;
